import CountryFlag from "vue-country-flag";

export default {
    props: {
        type: {
            type: String,
            default: "",
        },
        value: {
            type: Object,
            default: function() {
                return {};
            },
        },
        label: {
            type: String,
            default: "",
        },
        progress: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "",
        },
        itemValue: {
            type: String,
            default: "id",
        },
        itemTitle: {
            type: String,
            default: "name",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        list: {
            type: Array,
            default: function() {
                return [];
            },
        },
        withTranslation: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            openSelect: false,
            selectedItem: this.value,
            langCodes: {
                uk: "ua",
                ru: "rus",
                en: "gb",
            },
        };
    },
    components: {
        CountryFlag,
    },
    watch: {
        value() {
            this.changeSelect(this.value);
        },
    },
    created() {
        this.selectedItem = this.value;
    },
    methods: {
        changeSelect(item) {
            this.selectedItem = item;
            this.$emit("input", item);
        },
        changeOpenSelect() {
            this.openSelect = !this.openSelect;
        },
        getForLang(langCode) {
            if (this.langCodes[langCode]) return this.langCodes[langCode];
            return langCode;
        },
    },
};
